export default "__VITE_ASSET__27dca896__"